import { render, staticRenderFns } from "./add-product-serial-manual.vue?vue&type=template&id=b857671a&scoped=true&"
import script from "./add-product-serial-manual.vue?vue&type=script&lang=js&"
export * from "./add-product-serial-manual.vue?vue&type=script&lang=js&"
import style0 from "./add-product-serial-manual.vue?vue&type=style&index=0&id=b857671a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b857671a",
  null
  
)

export default component.exports